<p-dialog
  [(visible)]="visible"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  (onHide)="onDestroy()"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '900px', maxWidth: '98vw' }"
>
  <ng-template pTemplate="header">
    <div
      class="flex flex-row w-full justify-content-between align-items-center gap-2"
    >
      <div class="flex flex-row align-items-center text-xl font-bold">
        <i class="fas fa-user text-2xl mr-2"></i>
        Editar ficha del paciente
      </div>
      <p-button
        icon="fas fa-file-medical"
        class="mr-2"
        label="Ir a ficha completa"
        [outlined]="true"
        (onClick)="goToPatient()"
      ></p-button>
    </div>
  </ng-template>

  <ng-container *ngIf="loading; else content">
    <div
      class="flex flex-row justify-content-center align-items-center"
      style="min-height: 200px"
    >
      <p-progressSpinner></p-progressSpinner>
    </div>
  </ng-container>

  <ng-template #content>
    <div class="flex flex-column">
      <div>
        <peritos-form
          #patientForm
          [tableModel]="pacienteModel"
          table="pacientes"
          [record]="paciente"
          [cols]="{ sm: 12, md: 4 }"
          [fieldConfig]="fieldConfig"
        ></peritos-form>
      </div>
      <div class="mt-3 flex mr-2 ml-3 gap-2 align-items-end">
        <div
          class="gap-2 text-overflow-ellipsis white-space-nowrap overflow-hidden transition-colors transition-duration-150 cursor-pointer select-none align-items-center border-1 border-300 border-bottom-none border-round-top py-2 px-4"
          [ngClass]="{
            'bg-blue-500 hover:bg-blue-600 text-white': activeTab === 0,
            'hover:surface-100': activeTab !== 0
          }"
          (click)="activeTab = 0"
        >
          <i class="fas fa-map-marker-alt text-lg mr-1"></i>
          <span class="font-medium hidden xl:inline-block">Direcciones</span>
        </div>
        <div
          class="gap-2 text-overflow-ellipsis white-space-nowrap overflow-hidden transition-colors transition-duration-150 cursor-pointer select-none align-items-center border-1 border-300 border-bottom-none border-round-top py-2 px-4"
          [ngClass]="{
            'bg-blue-500 hover:bg-blue-600 text-white': activeTab === 1,
            'hover:surface-100': activeTab !== 1
          }"
          (click)="activeTab = 1"
        >
          <i class="fas fa-envelope text-lg mr-1"></i>
          <span class="font-medium hidden xl:inline-block">Emails</span>
        </div>
        <div
          class="gap-2 text-overflow-ellipsis white-space-nowrap overflow-hidden transition-colors transition-duration-150 cursor-pointer select-none align-items-center border-1 border-300 border-bottom-none border-round-top py-2 px-4"
          [ngClass]="{
            'bg-blue-500 hover:bg-blue-600 text-white': activeTab === 2,
            'hover:surface-100': activeTab !== 2
          }"
          (click)="activeTab = 2"
        >
          <i class="fas fa-phone text-lg mr-1"></i>
          <span class="font-medium hidden xl:inline-block">Teléfonos</span>
        </div>
      </div>
      <div
        class="overflow-hidden mx-1 mb-2 px-2 border-round surface-border border-1"
        style="max-height: 26rem"
        [hidden]="activeTab !== 0"
      >
        <app-grid-crud
          table="pac_direcciones"
          title="Direcciones"
          singleTitle="dirección"
          icon="fas fa-map-marker-alt"
          [tableModel]="pacDireccionesModel"
          [excludeColumns]="['id_paciente']"
          [excludeFields]="['id_paciente']"
          [baseRecord]="{
            id_paciente: idPaciente
          }"
          [fieldConfig]="{
            direccion: {
              expressions: {
                'props.required':
                  '!model.direccion && !model.poblacion && !model.provincia && !model.codigo_postal'
              }
            },
            poblacion: {
              expressions: {
                'props.required':
                  '!model.direccion && !model.poblacion && !model.provincia && !model.codigo_postal'
              }
            },
            provincia: {
              expressions: {
                'props.required':
                  '!model.direccion && !model.poblacion && !model.provincia && !model.codigo_postal'
              }
            },
            codigo_postal: {
              expressions: {
                'props.required':
                  '!model.direccion && !model.poblacion && !model.provincia && !model.codigo_postal'
              }
            }
          }"
          [filter]="[
            { field: 'id_paciente', operator: '=', value: idPaciente }
          ]"
        />
      </div>
      <div
        class="overflow-hidden mx-1 mb-2 px-2 border-round surface-border border-1"
        style="max-height: 20rem"
        [hidden]="activeTab !== 1"
      >
        <app-grid-crud
          table="pac_emails"
          title="Emails"
          singleTitle="email"
          icon="fas fa-envelope"
          [tableModel]="pacEmailsModel"
          [excludeColumns]="['id_paciente']"
          [excludeFields]="['id_paciente']"
          [fieldConfig]="{
            observaciones: {
              type: 'textarea'
            },
            email: {
              validators: {
                validation: ['email']
              }
            }
          }"
          [baseRecord]="{
            id_paciente: idPaciente
          }"
          [filter]="[
            { field: 'id_paciente', operator: '=', value: idPaciente }
          ]"
        />
      </div>
      <div
        class="overflow-hidden mx-1 mb-2 px-2 border-round surface-border border-1"
        style="max-height: 26rem"
        [hidden]="activeTab !== 2"
      >
        <app-grid-crud
          table="pac_telefonos"
          title="Teléfonos"
          singleTitle="teléfono"
          icon="fas fa-phone"
          [tableModel]="pacTelefonosModel"
          [excludeColumns]="['id_paciente']"
          [excludeFields]="['id_paciente']"
          [fieldConfig]="{
            observaciones: {
              type: 'textarea'
            }
          }"
          [baseRecord]="{
            id_paciente: idPaciente
          }"
          [filter]="[
            { field: 'id_paciente', operator: '=', value: idPaciente }
          ]"
        />
      </div>
      <div class="flex flex-row justify-content-end gap-2 mt-4">
        <p-button
          type="button"
          label="Cerrar"
          [text]="true"
          icon="pi pi-times"
          severity="secondary"
          (click)="visible = false"
          [disabled]="saving"
        />
        <p-button
          type="button"
          label="Guardar"
          icon="pi pi-save"
          (click)="save()"
          [loading]="saving"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
